import React from "react";
import { GoTag } from "react-icons/go";
import { FaRegCommentAlt } from "react-icons/fa";
import { CiUser } from "react-icons/ci";
import logo from "../../Assets/Blog Details/userImage.svg";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { IoLinkOutline } from "react-icons/io5";
import { FaPinterestP } from "react-icons/fa";

const BlogImageHeading = () => {
  const userDetails = [
    {
      type: "food",
      user: "By Admin",
      comments: "65 Comments",
    },
  ];

  const time = [
    {
      date: "4",
      month: "April",
      year: "2021",
    },
  ];

  return (
    <div className="w-full px-4 md:px-10">
      <div className="border-b-2 w-full xl:w-[872px] grid gap-4">
        {/* Meta info row */}
        <div className="text-[#4D4D4D] text-xs md:text-xs xl:text-sm">
          {userDetails.map((userDetail, index) => (
            <div
              key={index}
              className="grid grid-cols-3 gap-4 items-start px-4 md:px-10"
            >
              <p className="inline-grid grid-flow-col auto-cols-max gap-1 text-sm">
                <span className="mt-1 text-[#29AAE1]">
                  <GoTag />
                </span>
                {userDetail.type}
              </p>

              <p className="inline-grid grid-flow-col auto-cols-max gap-1 text-sm">
                <span className="mt-1 text-[#29AAE1]">
                  <CiUser />
                </span>
                {userDetail.user}
              </p>

              <p className="inline-grid grid-flow-col auto-cols-max gap-1 text-sm">
                <span className="mt-1 text-[#29AAE1]">
                  <FaRegCommentAlt />
                </span>
                {userDetail.comments}
              </p>
            </div>
          ))}
        </div>

        {/* paragraph */}
        <div className="py-2 w-full xl:w-[872px]">
          <p className="font-medium text-lg md:text-[32px]">
            Contrary to popular belief, Lorem Ipsum is not simply random text.
          </p>
        </div>

        {/* user info */}
        <div className="grid grid-cols-1 md:grid-cols-2 items-center w-full xl:w-[872px] gap-4 py-2 md:py-6">
          {/* left side */}
          <div className="grid grid-flow-col auto-cols-max items-start gap-2 md:gap-4">
            {/* user image */}
            <div>
              <img src={logo} alt="User" />
            </div>

            {/* user name, info */}
            <div className="grid">
              <p className="font-medium text-md text-[#1A1A1A]">
                Cameron Williamson
              </p>
              <div className="grid grid-flow-col auto-cols-max items-center gap-2">
                <div className="text-[#4D4D4D] text-xs sm:text-sm md:text-xs xl:text-sm">
                  {time.map((uploadTime, index) => (
                    <div
                      key={index}
                      className="grid grid-flow-col auto-cols-max items-center gap-1"
                    >
                      <p className="text-sm text-[#808080]">
                        {uploadTime.date}
                      </p>
                      <p className="text-sm text-[#808080]">
                        {uploadTime.month},
                      </p>
                      <p className="text-sm text-[#808080]">
                        {uploadTime.year}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="grid grid-flow-col auto-cols-max items-center gap-2">
                  <span className="text-[#808080]">•</span>
                  <p className="text-[#808080]">6 min read</p>
                </div>
              </div>
            </div>
          </div>

          {/* right side - social icons */}
          <div className="grid grid-flow-col auto-cols-max justify-start md:justify-end gap-4">
            {[
              FaFacebookF,
              FaTwitter,
              FaPinterestP,
              FaInstagram,
              IoLinkOutline,
            ].map((Icon, i) => (
              <a key={i} href="#">
                <span className="rounded-full text-[#4D4D4D] text-lg hover:text-white hover:bg-[#29AAE1] p-2 transition-colors duration-200 grid place-items-center">
                  <Icon />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogImageHeading;
